import { RelayPaginationNav } from './RelayPagination';
import { RelayPaginationState } from './state';

export type RelayPaginationActionPayload = {
    type: 'RELAY_PAGINATION_ACTION';
    paginationNav: RelayPaginationNav;
    count?: number;
}

export function reduceRelayPaginationAction (state: RelayPaginationState, payload: RelayPaginationActionPayload): RelayPaginationState {
    if (payload.count) {
        return state.newPage(payload.count, payload.paginationNav);
    } else {
        return state;
    }
}
